export const API_ENDPOINT = {
  AUTH_TOKEN: "/api/auth/token",
  CHAT_ROOMS: "/api/rooms",
  CHAT_ROOM_CREATE: "/api/rooms/direct",
  USER_BASE: "/api/users",
  CHAT_BLOCK_USERS: "/api/users/blocked",
  FILE_UPLOAD: "/api/upload",
  MAIL_CONTACT: "/home/mail_contact/",
  USER_INFO: "/common/user_info_by_uuid",
  SALE_INFO: "/common/sale_info_by_uuid/",
};
